import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { PageLoader } from '../../components/ui';
import { Seo } from '../../components/Seo';
import { useAuth } from '../../context/AuthContext';

const LINKS = [
  { to: '/hesabim', label: 'Genel bakış', end: true },
  { to: '/hesabim/kuponlarim', label: 'Kuponlarım' },
  { to: '/hesabim/siparisler', label: 'Siparişlerim' },
  { to: '/hesabim/iadeler', label: 'İadelerim' },
  { to: '/hesabim/favoriler', label: 'Favorilerim' },
  { to: '/hesabim/adresler', label: 'Adreslerim' },
  { to: '/hesabim/profil', label: 'Profil bilgileri' },
  { to: '/hesabim/guvenlik', label: 'Güvenlik' },
];

/** Giris zorunlu alan. Oturum yoksa girise yonlendirir. */
export function AccountLayout() {
  const { isAuthenticated, booting } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!booting && !isAuthenticated) {
      const target = `${window.location.pathname}${window.location.search}`;
      navigate(`/giris?devam=${encodeURIComponent(target)}`, { replace: true });
    }
  }, [booting, isAuthenticated, navigate]);

  if (booting) return <PageLoader label="Oturum kontrol ediliyor…" />;
  if (!isAuthenticated) return null;

  return (
    <div className="container-page py-8">
      <Seo title="Hesabım" noIndex />
      <h1 className="mb-6 text-2xl font-semibold tracking-tight text-ink-900">Hesabım</h1>

      <div className="grid gap-8 lg:grid-cols-[220px_1fr]">
        <nav aria-label="Hesap menüsü" className="lg:sticky lg:top-24 lg:self-start">
          <ul className="flex gap-1 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
            {LINKS.map((link) => (
              <li key={link.to} className="shrink-0">
                <NavLink
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    `block whitespace-nowrap rounded-lg px-3.5 py-2.5 text-sm transition ${
                      isActive
                        ? 'bg-ink-900 font-medium text-white'
                        : 'text-ink-600 hover:bg-ink-100 hover:text-ink-900'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
